import { useQuery } from '@tanstack/react-query'

import { InjectionTokens } from '@/controller/tokens'

import { MeteorologyLayer } from '@/domain/protocols/Meteorology'

import { IMeteorologyRepository } from '@/data/MeteorologyRepository/IMeteorologyRepository'

import { useInjection } from '@/presentation/contexts/InjectionContext'
import { queryKeys } from '@/presentation/queries/queryKeys'
import { domainQueryOptions } from '@/presentation/queries/queryOptions'
import { unwrap } from '@/presentation/queries/resultQuery'

/**
 * Manifest de uma camada de meteorologia.
 *
 * Existe compartilhado porque dois presenters em módulos diferentes o consomem
 * (`MapMeteorologyPresenter` e `MeteorologyControlPresenter`) e, pior, o mapa o buscava **por frame**
 * da animação: uma vez no presenter e outra dentro do `getGeoJson`, ou seja 2 requisições de manifest
 * por frame. O `staleTime` resolve o TODO que estava no `MeteorologyControlPresenter`
 * ("fazer o download do manifesto apenas se o layer mudar").
 */
export function useMeteorologyManifestQuery(layer: MeteorologyLayer | null) {
  const meteorologyRepository = useInjection<IMeteorologyRepository>(InjectionTokens.MeteorologyRepository)

  return useQuery({
    queryKey: queryKeys.meteorology.manifest(layer ?? ''),
    enabled: Boolean(layer),
    queryFn: () => unwrap(() => meteorologyRepository.getManifestByLayerName(layer)),
    ...domainQueryOptions.meteorologyManifest
  })
}
